module.exports = __webpack_public_path__ + "static/media/reversecover-2.72fc8345.pdf";